import { getConfig } from '@cian/config/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';
import { registry as getMicrofrontendsRegistry } from '@cian/mf-registry/browser';
import { IApplicationContext, IApplicationContextCustom } from 'shared/types/applicationContext';
import { ERuntimeSettings } from '../../../shared/types/runtimeSettings';
import { getTelemetry } from '@cian/telemetry/browser';
import { createMicrofrontendsAPI } from '../microfrontends/createMicrofrontendsAPI';

export const createContext = (): IApplicationContext => {
  const config = getConfig();

  return {
    config,
    custom: config.getStrict<IApplicationContextCustom>(ERuntimeSettings.applicationContextCustom),
    httpApi: getHttpApi(),
    logger: getLogger(),
    telemetry: getTelemetry(),
    microfrontendsRegistry: getMicrofrontendsRegistry(),
    microfrontendsAPI: createMicrofrontendsAPI(),
  };
};
